import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { history } from 'src';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { ApplicationState } from 'src/store';
import { getEventbyGroupID, hideEvents } from 'src/store/events/actions';
import { CardEvent, EventActionTypes } from 'src/store/events/types';
import { formatDate, WeekDays, DateShortForms } from 'src/utils/dateHelper';
import { action } from 'typesafe-actions';
import { ISeasonData, Season } from 'src/store/season/types';
import { getSeasons } from 'src/store/season/actions';

import * as moment from 'moment';

interface Props {
  events: CardEvent[];
  pending: boolean;

  seasonData: ISeasonData;
  hideEvents: typeof hideEvents;
  getEventbyGroupID: typeof getEventbyGroupID;
  getSeasons: typeof getSeasons;
  setEventHidden: (eventId: number) => any;
}

interface RouteProps {
  eventId: string;
  sectionTitle: string;
}

type AllType = Props & RouteComponentProps<RouteProps>;

class HideEvent extends React.Component<AllType> {
  eventId: number;
  sectionTitle: string;

  constructor(props: AllType) {
    super(props);

    this.eventId = +this.props.match.params.eventId;
    this.sectionTitle = this.props.match.params.sectionTitle;
  }

  componentDidMount() {
    if (!isNaN(+this.eventId)) {
      this.props.getEventbyGroupID(+this.eventId);
      this.props.getSeasons(this.sectionTitle);
    } else {
      history.push('/404');
    }
  }

  onSubmit = (e: any) => {
    e.preventDefault();
    this.props.hideEvents(this.props.events, () => {
      history.push(this.props.match.url.replace('/hide', ''));
    });
  };

  onSeasonSelected = (season: Season) => {
    this.props.events.forEach(ev => {
      if (
        moment(ev.begins).isSameOrAfter(season.startdate) &&
        moment(ev.begins).isSameOrBefore(season.enddate)
      ) {
        this.props.setEventHidden(ev.id);
      }
    });
  };

  onWeekDaySelected = (num: number) => {
    this.props.events.forEach(ev => {
      console.log(moment(ev.begins).isoWeekday());
      if (moment(ev.begins).isoWeekday() === num + 1) {
        this.props.setEventHidden(ev.id);
      }
    });
  };

  renderCheckboxes = () => {
    const ret = [];
    const name = 'weekday';
    for (const item in WeekDays) {
      if (!isNaN(Number(item))) {
        const itemNum = Number(item);
        ret.push(
          <div key={itemNum} className="blockCheckbox">
            <input
              name={name}
              id={name + itemNum}
              onClick={this.onWeekDaySelected.bind(this, itemNum)}
              type="checkbox"
              value={itemNum}
            />
            <label htmlFor={name + itemNum}>{DateShortForms[WeekDays[itemNum]]}</label>
          </div>
        );
      }
    }
    return ret;
  };

  render() {
    const { events, seasonData } = this.props;

    const allIds = seasonData.bySectionTitle[this.sectionTitle];

    return (
      <div className="container">
        <div>
          {seasonData &&
            allIds &&
            seasonData.byId &&
            allIds.map((idx, keyx) => {
              const season = seasonData.byId[idx];

              if (season) {
                return (
                  <div key={keyx} className="blockCheckbox wide">
                    <input
                      onClick={this.onSeasonSelected.bind(this, season)}
                      name={season.title}
                      id={'' + season.id}
                      type="checkbox"
                      value={season.id}
                    />
                    <label htmlFor={'' + season.id}>{season.title}</label>
                  </div>
                );
              } else {
                return null;
              }
            })}
        </div>
        <div style={{ marginTop: '10px' }}>{this.renderCheckboxes()}</div>
        <div className="blockCheckbox" />
        <div className="col-sm-12 centered">
          <form onSubmit={this.onSubmit}>
            <table className="styled lastOff">
              <thead>
                <tr>
                  <th>Versteckt</th>
                  <th>Datum</th>
                  <th>Titel</th>
                </tr>
              </thead>
              <tbody>
                {events &&
                  events.map((ev, key) => (
                    <tr key={key} style={{ textDecoration: ev.hidden ? 'line-through' : 'none' }}>
                      <td>
                        <div className="styledCheckbox">
                          <input
                            id={'event' + ev.id}
                            type="checkbox"
                            onChange={() => {
                              this.props.setEventHidden(ev.id);
                            }}
                            value={ev.hidden ? 1 : 0}
                            checked={ev.hidden}
                          />
                          <label htmlFor={'event' + ev.id} />
                        </div>
                      </td>
                      <td>{formatDate(ev.begins, 'DD.MM.YYYY')}</td>
                      <td>{ev.title}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <LoadingSpinner pending={this.props.pending} />

            <button style={{ margin: '40px 0 80px 0' }}>Speichern</button>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ events, season }: ApplicationState) => ({
  events: events.data.byCardGroup,
  pending: events.loading,
  seasonData: season.data
});

const mapDispatchToProps = (dispatch: any) => ({
  hideEvents: (events: CardEvent[], successCB: () => any) =>
    dispatch(hideEvents(events, successCB)),
  getEventbyGroupID: (cardGroupId: number) => dispatch(getEventbyGroupID(cardGroupId)),
  setEventHidden: (eventId: number) => dispatch(action(EventActionTypes.SET_EVENT_HIDDEN, eventId)),
  getSeasons: (sectionTitle: string) => dispatch(getSeasons(sectionTitle))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HideEvent);



// WEBPACK FOOTER //
// ./src/pages/Event/HideEvent/HideEvent.tsx